import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProjectSettingsCreateModalComponent } from 'src/app/project/project-settings/project-settings-create-modal/project-settings-create-modal.component';
import { Project } from 'src/app/project/shared/interfaces/project.interface';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ProjectService } from 'src/app/project/shared/services/project.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ProjectDataService } from 'src/app/project/shared/services/project-data.service';
import { MatDialog } from '@angular/material/dialog';
import { RouteStationService } from 'src/app/project/shared/services/route-station.service';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { ModalService } from 'src/app/shared/modal/shared/modal.service';
import { ReportService } from 'src/app/dashboard/shared/services/report.service';
import { Subscription } from 'rxjs';
import { ProjectRouteStation } from 'src/app/project/shared/interfaces/project-route-station.interface';
import { ProjectRouteStationWithParam } from 'src/app/project/shared/interfaces/project-route-station.class';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { ErrorMessageService } from '../shared/service/error-message.service';
import { ErrorMessage } from '../shared/interfaces/error-message.interface';
import { ErrorMessagesCollection } from '../shared/interfaces/error-messages-collection.interface';
import { ErrorType } from '../shared/enums/error-type.enum';
import { RequestBodyErrorMessages } from '../shared/interfaces/request-body-error-messages.interface';
import { getErrorTypeString } from '../shared/enums/error-type.enum';
import { ProjectGroup } from 'src/app/project/shared/interfaces/project-group.interface';


interface ProjectNode {
  name: string;
  children?: GroupNode[];
  status?: string;
  active?: boolean;
  inactive?: boolean;
  archived?: boolean;
  projectId?: number;
  groupId?: number;
}

interface GroupNode {
  name: string;
  children?: DeviceNode[];
  groupId?: number,
  projectId?: number
}

interface DeviceNode {
  name: string;
  samId?: number,
}

interface DeviceTreeNode {
  name: string;
  groupName?: string;
  children?: GroupNode[];
  groupId?: number;
  samId?: number;
  guid?: string;
}

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  groupId?: number;
}

const today = new Date();
const month = today.getMonth();
const year = today.getFullYear()
const day = today.getDate();
@Component({
  selector: 'avs-error-messages',
  standalone: false,

  templateUrl: './error-messages.component.html',
  styleUrl: './error-messages.component.css'
})
export class ErrorMessagesComponent implements OnInit, OnDestroy {
  public projects: Project[] = [];
  public selectedProject: SelectInput = { name: 'alle Projekte', id: 0 };
  public selectedGroup: SelectInput = { name: 'alle Gruppen', id: 0 };
  public selectedStatus = 'aktiv'
  public selectedDevice = 'alle'
  public activeTab: string = 'Projekt-Übersicht';
  public showTree: boolean = true;
  public searchFilter: string = '';
  public searchFilterTree: string = '';
  public projectReportData: ProjectNode[] = [];
  public tabs = ['Projekt-Übersicht', 'Geräte-Übersicht'];
  private subscriptionCollection: Subscription[] = [];
  private projectSubscription: Subscription;
  public range = new FormGroup({
    start: new FormControl(new Date(year, month, 1)),
    end: new FormControl(new Date(year, month + 2, 0)),
  });
  public projectSelectInput: SelectInput[] = [];
  public routeStationReportData: DeviceTreeNode[] = [];

  public projectRouteStations: ProjectRouteStation[] = [];
  public minDate: Date;
  public maxDate: Date;
  public selected = new FormControl(0);
  public isGroupSelected?: boolean;

  public now = new Date();
  public nowAsISOString: string;
  public twoDaysAgoAsString: string;
  public selectedDeviceTree: SelectInput = { name: '-', samId: 0 };
  public isLoading: boolean = false;
  public activeRouteStation: ProjectRouteStationWithParam | undefined;
  public errorMessages: ErrorMessage[] = [];
  public errorMessagesCollection: ErrorMessagesCollection[] = [];

  public selectedErrorLevel?: number;
  public selectedErrorType?: number;
  getErrorTypeString = getErrorTypeString;
  public groups: ProjectGroup[] = [];

  constructor(private readonly projectService: ProjectService,
    private readonly projectDataService: ProjectDataService,
    private readonly dialog: MatDialog,
    private readonly routeStationService: RouteStationService,
    private alertService: AlertService,
    private modalService: ModalService,
    private reportService: ReportService,
    private errorMessageService: ErrorMessageService
  ) {
    this.projectSubscription = projectDataService.projects.subscribe(projects => {
      if (projects.length > 0) {
        this.projects = projects;
        this.fillProjectSelectInput(projects);
      }
    });
    const currentYear = new Date().getFullYear();
    this.minDate = new Date(currentYear - 20, 0, 1);
    this.maxDate = new Date()/* heute */
    this.nowAsISOString = this.now.toISOString()
    let d = new Date();
    d.setDate(d.getDate() - 2);
    this.twoDaysAgoAsString = d.toISOString()
  }

  public ngOnInit(): void {
    this.projectService.getProjects().subscribe(projects => {
      projects.forEach(project => {
        let children: GroupNode[] = [];
        project.groups.forEach(group => {
          children.push({ name: group.name, children: [], groupId: group.id });
        });
        this.projectReportData.push({ name: project.name, children: children, active: project.isActive, inactive: !project.isActive, projectId: project.id });
      });
      this.dataSource.data = this.projectReportData;
      this.filterDataSource();
      this.projectDataService.updateProjects(projects);
    });
    this.routeStationService.getRouteStations().subscribe(routeStations => {
      this.projectRouteStations = routeStations;
      routeStations.forEach(routeStation => {

        this.routeStationReportData.push({ name: routeStation.name, groupId: routeStation.groupId, samId: routeStation.samId, guid: routeStation.id, children: [] });
      });
      this.dataSourceRouteStations.data = this.routeStationReportData;
    })
    this.subscriptionCollection.push(this.projectSubscription!);
  }

  public ngOnDestroy(): void {
    this.subscriptionCollection.forEach(sub => sub.unsubscribe());
  }

  private fillProjectSelectInput(projects: Project[]): void {
    this.projectSelectInput = [];
    this.projectSelectInput.push({ name: 'alle Projekte', id: 0 });
    for (let project of projects) {
      let selectItem = {
        name: project.name,
        id: project.id
      } as SelectInput;
      this.projectSelectInput.push(selectItem);
      this.groups.push(...project.groups);
    }
  }
  public setProjectIdByName(node: ProjectNode): void {
    let NameParts = node.name.split(' ')
    let cleanName = node.name.split(' ').slice(1).join(' ')
    let projectIdpart = NameParts[0].split(':')[1]
    let projectId = projectIdpart.split(';')[0]
    this.selectedGroup = { name: '', id: 0 };
    this.isGroupSelected = false;
/*     this.downloadType = 'json';
 */    let project = this.projectReportData.find(project => cleanName === node.name);
    this.selectedProject = { name: cleanName, id: projectId };
    this.selectedGroup = { name: 'alle Gruppen', id: 0 };
  }
  public returnCleanName(name: string): string {
    return name.split(' ').slice(1).join(' ');
  }
  public setSamIDByName(node: DeviceTreeNode): void {
    this.triggerLoadingSpinner();
    let samId = node.name.split(' ')[1]
    this.selectedDeviceTree = { name: '', samId: 0 };
/*     this.downloadType = 'json';
 */    this.selectedDeviceTree = { name: node.name, samId: +(samId) };
    this.selectedGroup = { name: 'alle Gruppen', id: 0 };
    this.selectedProject = { name: 'alle Projekte', id: 0 };

    // Nur die Stammdaten der Station werden gebraucht — kein Parameter-Request nötig
    this.isLoading = false;
    this.activeRouteStation = new ProjectRouteStationWithParam({} as ProjectRouteStation);
    this.activeRouteStation.routeStation = this.projectRouteStations.find(routeStation => routeStation.samId === +(samId))!;
  }

  public resetTree(): void {
    this.searchFilter = '';
    this.filterDataSource();
  }

  public setGroupIdByName(node: GroupNode): void {

    let NameParts = node.name.split(' ')
    let cleanName = node.name.split(' ').slice(1).join(' ')
    let projectIdpart = NameParts[0].split(':')[1]
    let projectId = projectIdpart.split(';')[0]

    let groupIdpart = NameParts[0].split(':')[2]
    let groupId = groupIdpart.split(';')[0]


    this.isGroupSelected = true;
/*     this.downloadType = 'json';
 */    this.projectReportData.forEach(project => {
      project.children?.forEach(group => {
        this.selectedGroup = { name: cleanName, id: groupId }
      })
    })
    if (Number(groupId) > 0) {
      let project = this.getProjectByGroupId(Number(groupId));
      this.projects.forEach(project => { project.groups.forEach(group => { if (group.name === node.name) { groupId = groupId; this.selectedGroup = { name: group.name, id: groupId } } }) })
      this.selectedProject = { name: project.name, id: project.id };
    }
    else
      this.alertService.alert('Keine Gruppen für dieses Projekt vorhanden', AlertTypes.error)
  }

  public getProjectByGroupId(projectId: number): Project {
    let project = this.projects.find(project => project.groups.find(group => group.id === projectId));
    return project!
  }
  public tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.activeTab = tabChangeEvent.tab.textLabel;
  }

  public getErrorMessages(): void {
    let from = this.range.value.start ? this.range.value.start.toISOString() : '';
    let to = this.range.value.end ? this.range.value.end.toISOString() : '';

    let requestBody: RequestBodyErrorMessages = {
      from: from,
      to: to,
      samId: this.selectedDeviceTree.samId === 0 ? undefined : Number(this.selectedDeviceTree.samId),
      groupId: this.selectedGroup.id === 0 ? undefined : Number(this.selectedGroup.id),
      projectId: this.selectedProject.id === 0 ? undefined : Number(this.selectedProject.id),
      errorLevel: this.selectedErrorLevel !== undefined ? Number(this.selectedErrorLevel) : undefined,  /* darf 0 sein === warnung */
      errorType: this.selectedErrorType === 0 ? undefined : Number(this.selectedErrorType)
    }
    this.getErrorMessagesViaService(requestBody);
  }

  private getErrorMessagesViaService(requestBody: RequestBodyErrorMessages): void {
    this.errorMessageService.getErrorMessages(requestBody.from, requestBody.to, requestBody.samId, requestBody.groupId, requestBody.projectId, requestBody.errorType, requestBody.errorLevel).subscribe(errorMessages => {
      this.errorMessages = errorMessages;
      this.errorMessagesCollection.push({ errorMessages: errorMessages, from: requestBody.from, to: requestBody.to, label: this.selectedGroup.name });
      this.tabs.push('Fehlermeldung ' + this.errorMessagesCollection.length);
      this.selected.setValue(this.tabs.length + 1);
    });
  }

  public getErrorMessagesBySamId(): void {
    let from = this.range.value.start ? this.range.value.start.toISOString() : '';
    let to = this.range.value.end ? this.range.value.end.toISOString() : '';
    let samId = this.selectedDeviceTree.samId;

    let requestBody: RequestBodyErrorMessages = {
      from: from,
      to: to,
      samId: samId === 0 ? undefined : Number(samId),
      groupId: undefined,
      projectId: undefined,
      errorLevel: this.selectedErrorLevel !== undefined ? Number(this.selectedErrorLevel) : undefined,  /* darf 0 sein === warnung */
      errorType: this.selectedErrorType === 0 ? undefined : Number(this.selectedErrorType)
    }
    this.getErrorMessagesViaService(requestBody);
  }

  public filterDataSource() {
    let filteredData: ProjectNode[] = [];
    this.dataSource.data = [];
    if (this.selectedStatus === 'aktiv') {
      let activeProjectsData = this.projectReportData.filter(project => project.active);
      activeProjectsData.forEach(project => filteredData.push(project as ProjectNode));
    }
    else if (this.selectedStatus === 'inaktiv') {
      let inactiveProjectsData = this.projectReportData.filter(project => project.inactive);
      inactiveProjectsData.forEach(project => { filteredData.push(project as ProjectNode) });
    }
    else if (this.selectedStatus === 'alle') {
      let activeProjectsData = this.projectReportData.filter(project => project.active);
      activeProjectsData.forEach(project => filteredData.push(project as ProjectNode));
      let inactiveProjectsData = this.projectReportData.filter(project => project.inactive);
      inactiveProjectsData.forEach(project => { filteredData.push(project as ProjectNode) });
    }
    this.dataSource.data = filteredData;
    if (this.searchFilter !== '') {
      this.dataSource.data = this.dataSource.data.filter(project => project.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
    }
  }
  public filterDataSourceTree() {
    this.dataSourceRouteStations.data = [];
    if (this.searchFilterTree === '') {
      this.dataSourceRouteStations.data = this.routeStationReportData;
    }
    if (this.searchFilterTree !== '') {
      this.dataSourceRouteStations.data = this.routeStationReportData.filter(rs => rs.name.toLowerCase().includes(this.searchFilterTree.toLowerCase()) || rs.samId?.toString().includes(this.searchFilterTree));
    }
  }

  private triggerLoadingSpinner() {
    this.isLoading = true;
    setTimeout(() => {
      if (this.isLoading) {
        this.modalService.openDialog('Fehler bei der Anfrage, bitte versuchen Sie es erneut', 'OK').subscribe();
        this.isLoading = false;
      }
    }, 30000);
  }
  
  public resetTreeTree(): void {
    this.searchFilterTree = '';
    this.filterDataSourceTree();
  }
  /* Tree Handling */
  private _transformer = (node: ProjectNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: 'ProjectId:' + node.projectId + ';' + 'GroupId:' + node.groupId + '; ' + node.name,
      level: level,

    };
  }

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  private _transformer2 = (node: DeviceTreeNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: 'SAM-ID: ' + node.samId + ' | ' + node.name,
      level: level,
    };
  }

  treeControl2 = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener2 = new MatTreeFlattener(
    this._transformer2,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  dataSourceRouteStations = new MatTreeFlatDataSource(this.treeControl2, this.treeFlattener2);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
}
